// HELPERS
import { currentYear } from "../../shared/helpers/helpDate";
// HOOKS
import { useSiteConfig } from "../../shared/hooks/useSiteConfig";
// CLASSES
import classes from "./modules/Footer.module.scss";
// COMPONENTS
import NavigationLinks from "./NavigationLinks.component";

function Footer() {
	// Correos, teléfonos y RIF, leídos en tiempo de ejecución desde /config.json
	const [config] = useSiteConfig();

	return (
		<footer className={`py-2 py-md-3 ${classes.Footer}`}>
			<div
				className={`mb-3 mb-xl-4 border-bottom d-flex justify-content-between justify-content-xl-around ${classes.ContainerGrid}`}
			>
				<ul className="nav flex-column flex-md-row justify-content-center pb-3">
					<NavigationLinks className={classes.FooterLink} />
				</ul>
				<ul className="col-md-2 justify-content-md-end list-unstyled d-flex flex-column flex-md-row mx-auto mx-md-0 pt-2">
					{config?.CONTACT_EMAIL && (
						<li className={`ms-3 ${classes.IconGrid}`}>
							<i className="fa-solid fa-envelope"></i>
							<a href={`mailto:${config.CONTACT_EMAIL}`}>Escríbenos al correo</a>
						</li>
					)}
					{config?.FOOTER_PHONES?.length > 0 && (
						<li className={`ms-3 ${classes.IconGrid}`}>
							<i className="fa-solid fa-phone"></i>
							{config.FOOTER_PHONES.map(({ label, tel }) => (
								<a key={tel} href={`tel:${tel}`}>{label}</a>
							))}
						</li>
					)}
				</ul>
			</div>
			<p className="text-center mb-2 mb-xl-1">
				© ATLANTIDA | Todos los derechos reservados, {currentYear()}{config?.RIF && ` | RIF ${config.RIF}`}
			</p>
		</footer>
	);
}

export default Footer;
